<div>
  Team <b>{{model.teamTitle}}</b>
</div>
<div>
  Completed Abstracts: <b>{{model.abstractsCompleted}}</b>
</div>
<div>
  Remaining Abstracts: <b>{{model.abstractsRemaining}}</b>
</div>
<div>
  Currently evaluating abstract or abstract group: <b>{{model.abstractGroupCurrentlyInProgress ? "Yes" : "No"}}</b>
</div>
<div *ngIf="model && model.abstractGroupCurrentlyInProgress">
  Currently evaluating ApplID <b><a [routerLink]='["/abstract/view/",model.abstractIdCurrentlyInProgress]'>{{model.applIdCurrentlyInProgress}}</a></b>
</div>
